import React from 'react';
import {
  Box,
  Button,
  Divider,
  ListItem,
  UnorderedList,
  Modal,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from 'ui';
import { ts } from './utils';
import { useController } from './hooks/useController';
import { style as s } from './ConfirmationModal.style';

export const ConfirmationModal = (props) => {
  const {
    type,
    isOpen,
    onClose,
    ...contentProps
  } = props;

  const {
    cardData,
    isLoading,
    onConfirm,
  } = useController({ type });

  const {
    Image,
    mustHave,
  } = cardData;

  return (
    <Modal
      {...contentProps}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton data-testid="close-button" />
        <ModalHeader {...s.title}>
          {ts('default.title')}
        </ModalHeader>
        <Divider />
        <ModalBody {...s.body}>
          <Box {...s.box}>
            <Image {...s.image} data-testid="image" />
          </Box>
          <UnorderedList>
            {mustHave.map((item) => (
              <ListItem key={item} {...s.listItem}>
                {item}
              </ListItem>
            ))}
          </UnorderedList>
          <Button
            {...s.button}
            onClick={onConfirm}
            isDisabled={isLoading}
          >
            {ts('default.confirm')}
          </Button>
          <Button
            onClick={onClose}
            variant="ghost"
            {...s.button}
          >
            {ts('default.fix')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
